import { render } from "./asterisk.vue?vue&type=template&id=acd82b8a&ts=true"
import script from "./asterisk.vue?vue&type=script&lang=ts"
export * from "./asterisk.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__